import { Button } from '@lifeomic/chroma-react/components/Button';
import React from 'react';
import { type KnowledgeBaseCitation } from '../../../../../util/knowledgeBaseCitation';
import { useOpenKnowledgeBaseFile } from './useOpenKnowledgeBaseFile';

export type KnowledgeBaseCitationInlineProps = {
  citation: KnowledgeBaseCitation;
};

/**
 * Opens KB-backed files via file-service (aligned with qa-agent citation handling).
 */
export const KnowledgeBaseCitationInline: React.FC<
  KnowledgeBaseCitationInlineProps
> = ({ citation }) => {
  const openKnowledgeBaseFile = useOpenKnowledgeBaseFile(citation);

  return (
    <Button
      variant="outlined"
      title={citation.title}
      onClick={() => void openKnowledgeBaseFile()}
    >
      {citation.displayName}
    </Button>
  );
};
